module.exports = __webpack_public_path__ + "img/Lputih.d34ecc48.png";